import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { selectUserInfo } from "../userInfo/userInfoSlice";
import { useAppSelector } from "../../app/hooks";
import { menuItems } from "../../constants/menu";
import { Trans } from "react-i18next";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import { CssBaseline } from "@mui/material";
import AppBar from "../address/AppBar";

const ForbiddenPage = () => {
  return (
    <Box sx={{ display: "flex" }}>
      <div>test</div>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme: any) => theme.zIndex.drawer + 1 }}
      />
      <Box
      sx={{
        paddingLeft: 3,
        paddingRight: 3,
        paddingTop: 10,
        textAlign: "center",
        flex: 1,
      }}
      >
        <Trans i18nKey="accessDeniedLabel">You don't have access to this feature, go back to <Link href="/">Home</Link></Trans>
      </Box>
    </Box>
  )
}

const checkPermission = (userInfo: any, location: any) => {
  const matchingItem = menuItems.find((item: any) => item.url === location.pathname);
  if (!matchingItem) {
    return;
  }
  
  const permissions = userInfo.value.rtp.filter((rtpPermission: any) => {
    return rtpPermission.resource === matchingItem.permission.resource && rtpPermission.scope.includes(matchingItem.permission.scope);
  })
  
  return permissions.length > 0;
}

export default function ProtectedRoute({ children }: { children: any }) {
  // const user = TokenService.getUser();
  const userInfo = useAppSelector(selectUserInfo);
  const location = useLocation();
  const [hasPermission, setHasPermission] = useState(checkPermission(userInfo, location));
  
  // if (!user) {
  //   return <Navigate to="/auth/signin" />;
  // }
  
  useEffect(() => {
    if (!userInfo.value) {
      return;
    }

    const hasPermission = checkPermission(userInfo, location);
    setHasPermission(hasPermission);
  }, [userInfo, location]);
  
  return <>
  {hasPermission && children}
  {!hasPermission && <ForbiddenPage />}
  </>;
}
